// 변경공사 액션(rpc) — 계약 상세의 지급회차 받음 표시.
import { rpc } from "@/api/client";

export const setContractPaymentPaid = (contractId: string, paymentId: string, paid: unknown, force = false) =>
  rpc("change-order/actions/setContractPaymentPaid", contractId, paymentId, paid, force);

export const createChangeOrder = (contractId: string, input: unknown) => rpc("change-order/actions/createChangeOrder", contractId, input);

export const saveChangeOrderDraft = (changeOrderId: string, input: unknown, baseRev: number) =>
  rpc("change-order/actions/saveChangeOrderDraft", changeOrderId, input, baseRev);

export const readContractPayments = (contractId: string, changeOrderId?: string) =>
  rpc("change-order/actions/readContractPayments", contractId, changeOrderId);

export const sendChangeOrder = (changeOrderId: string) => rpc("change-order/actions/sendChangeOrder", changeOrderId);

export const acceptChangeOrderByStaff = (changeOrderId: string, input: unknown) =>
  rpc("change-order/actions/acceptChangeOrderByStaff", changeOrderId, input);

export const rejectChangeOrder = (changeOrderId: string, reason: unknown) => rpc("change-order/actions/rejectChangeOrder", changeOrderId, reason);

export const voidChangeOrder = (changeOrderId: string, reason: unknown) => rpc("change-order/actions/voidChangeOrder", changeOrderId, reason);

export const recreateChangeOrder = (changeOrderId: string) => rpc("change-order/actions/recreateChangeOrder", changeOrderId);
